import type { DocMigration } from "../docMigration";

const MIN_ROOM_SQ_FT_FOR_INTERIOR_DIMENSIONS = 6;

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_451: DocMigration = {
  maxSchemaVersion: "0.0.451",
  description: "Adds interior dimension area threshold to area report settings",
  apply(json: any) {
    if (json.settings) {
      for (const settingId of Object.keys(json.settings)) {
        const planSettings = json.settings[settingId];
        if (planSettings.type !== "PLAN_SETTINGS") {
          continue;
        }

        const interiorDimensionType = planSettings.interiorDimensionType;
        if (interiorDimensionType === "BY_STRING") {
          planSettings.interiorDimensionAreaThreshold = 0;
        } else if (interiorDimensionType === "BY_ROOM_GROUP") {
          planSettings.interiorDimensionAreaThreshold = MIN_ROOM_SQ_FT_FOR_INTERIOR_DIMENSIONS;
        }

        json.settings[settingId] = planSettings;
      }
    }
    return json;
  },
};

export default migration_0_0_451;
